import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PicklistsService {

  //declare variables
  private customerStatus: any[] = [
    'Downloaded', 'Installed', 'Configuring', 'Proof of Concept (POC)/Evaluation', 'Production', 'Pending Procurement', 'Purchased', 'Did Not Purchase'
  ];
  private licenseTypes: any[] = [
    'Community', 'Enterprise'
  ];
  private contactRoles: any[] = [
    'Auditor/Compliance', 'Buyer/Procurement', 'Cyber Security', 'Developer', 'Executive/Decision Maker', 'Infrastructure'
  ];
  private useCases: any[] = [
    'Cyber Security', 'Environmental Compliance', 'Internal Audit', 'Other', 'Quality Assurance', 'Safety', 'Security'
  ];
  private contactReasons: any[] = [
    'Ask a Question', 'Feature Request', 'Other', 'Partner Program Information', 'Pricing Information/Quote', 'Renew License', 'Report a Bug', 'Request a Demo'
  ]
  private industryTypes: any[] = [
    'Automotive', 'Banking/Financial Services', 'Education', 'Engineering', 'Energy (Oil, Gas, Nuclear)', 'Food and Beverage', 'Government - Federal, State, or Local', 'Healthcare', 'Insurance', 'Legal', 'Manufacturing', 'Media/Online', 'Non-Profit', 'Other', 'Real-Estate', 'Religious', 'Technology', 'Telecommunications', 'Transportation'
  ];
  private jobTitles: any[] = [
    'C Level', 'Vice President (VP)', 'Manager', 'IT Staff', 'Cyber Security Staff', 'Risk/Compliance Staff', 'Quality Staff', 'Supply Chain/Procurement Staff', 'Auditor', 'Other'
  ];

  constructor() { }

  //return the customer status 
  getStatus() {
    return this.customerStatus;
  }

  //return the license types
  getLicenseTypes() {
    return this.licenseTypes;
  }

  //return the contact roles
  getContactRoles() {
    return this.contactRoles;
  }

  //return the use cases
  getUseCases() {
    return this.useCases;
  }

  //return the contact reasons
  getContactReasons() {
    return this.contactReasons;
  }

  //return the industry list
  getIndustries() {
    return this.industryTypes;
  }

  //return the job titles
  getJobTitles() {
    return this.jobTitles;
  }
}
